import * as types from '../actions/_actionTypes';
import initialState from './_initialReducerState'

export default function SelectedDfsReducer(state = initialState.selectedDfs, action: any) {
  switch (action.type) {
    case types.SAVE_SELECTED_DFS_SUCCESS:
      return action.selectedDfs;
    default:
      return state;
  }
}
